<template>
  <div class="text-options-data-dialog">
    <el-collapse v-model="activeNames">
      <el-collapse-item title="数据绑定" name="1" v-if="pageType === 'detailPage' || pageType === 'listPage'">
        <div v-if="pageType === 'detailPage'" :class="detailFieldMappingFieldFlag ? 'mapping_content checked' : 'mapping_content'">
          <div class="verticallyBetweenCenter">
            <div class="content-title">
              {{ getValueByTypeHandle(options.innerElement) }}
            </div>
          </div>
          <div class="select_content mt8">
            <el-select style="width: 100%" v-model="detailFieldMappingFieldFlag" placeholder="请选择" clearable>
              <el-option
                v-for="(item, index) in detailFieldMappingList"
                :key="index"
                :label="item.label"
                :value="item.value"
              >
                <span style="font-size: 13px">{{ item.label }}</span>
              </el-option>
            </el-select>
          </div>
          <div class="verticallyCenter mapping_date_content mt8">
            <label class="date-label">显示为:</label>
            <el-dropdown trigger="click" @command="onChangeMappingType">
              <span class="el-dropdown-link">
                {{ fieldMappingDataTypeName }}<i class="el-icon-arrow-down el-icon--right"></i>
              </span>
              <el-dropdown-menu slot="dropdown" class="custom-dropdown">
                <el-dropdown-item v-for="item in dataTypeList" :key="item.value" :command="item.value">
                  <div :class="detailFieldMappingDataType === item.value ? 'dropdown-item active' : 'dropdown-item'">
                    {{ item.label }}
                  </div>
                </el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </div>
        </div>
        <div v-else-if="pageType === 'listPage'">
          <listPageFieldMappingSetting :myid="ids" :options="options"></listPageFieldMappingSetting>
        </div>
      </el-collapse-item>
    </el-collapse>
  </div>
</template>

<script>
import { getValueByType } from "utils"
import listPageFieldMappingSetting from "publicSetting/listPageFieldMappingSetting.vue"

export default {
  name: "noteEditor-options-data",
  components: { listPageFieldMappingSetting },
  props: {
    options: {
      type: Object
    }
  },
  data() {
    return {
      activeNames: ["1"],
      dataTypeList: [
        {
          label: "字段名称：字段内容",
          value: "dataKey"
        },
        {
          label: "字段内容",
          value: "dataValue"
        }
      ],
      detailFieldMappingList: [] // 详情页数据源
    }
  },
  computed: {
    ids() {
      return this.$store.state.states.activeID
    },
    pageType() {
      return this.$store.state[this.request_prefix].type
    },
    detailFieldMapping() {
      return this.options.detailFieldMapping
    },
    detailFieldMappingDataType: {
      get() {
        return this.detailFieldMapping?.dataType || "dataValue"
      },
      set(newVal) {
        if (!this.detailFieldMapping) {
          this.$changeOptionsEV(
            {
              isChecked: true,
              dataType: newVal,
              fieldFlag: ""
            },
            "detailFieldMapping",
            false
          )
        } else {
          this.$changeOptionsEV(newVal, "detailFieldMapping.dataType", false, null, {
            ...this.ids
          })
        }
      }
    },
    detailFieldMappingFieldFlag: {
      get() {
        // 兼容老数据，必须要noCacheComponent和isChecked为true才生效
        if (this.options.noCacheComponent && this.detailFieldMapping) {
          return this.detailFieldMapping.isChecked ? this.detailFieldMapping.fieldFlag : ""
        } else {
          return ""
        }
      },
      set(newVal) {
        if (!this.detailFieldMapping) {
          this.$changeOptionsEV(
            [
              true,
              {
                isChecked: true,
                dataType: "dataValue",
                fieldFlag: newVal
              }
            ],
            ["noCacheComponent", "detailFieldMapping"],
            false
          )
        } else {
          this.$changeOptionsEV(
            [true, true, newVal],
            ["noCacheComponent", "detailFieldMapping.isChecked", "detailFieldMapping.fieldFlag"],
            false
          )
        }
      }
    },
    fieldMappingDataTypeName() {
      const item = this.dataTypeList.find(data => data.value === this.detailFieldMappingDataType)
      return item?.label || ""
    }
  },
  created() {
    if (window.localStorage.getItem("detailData")) {
      const detailData = JSON.parse(window.localStorage.getItem("detailData"))[0]
      Object.keys(detailData).forEach((key, index) => {
        if (key === "content" || key === "id" || key === "formId") return
        if(detailData[key]?.key){
          const temp = {
            value: key,
            label: detailData[key].key
          }
          this.detailFieldMappingList.push(temp)
        }
      })
      this.detailFieldMappingList.push({
        value: "content",
        label: "数据详情"
      })
    }
  },
  methods: {
    getValueByTypeHandle(type) {
      return getValueByType(type)
    },
    onChangeMappingType(value) {
      this.detailFieldMappingDataType = value
    }
  }
}
</script>

<style lang="scss" scoped>
.mapping_content {
  padding: 8px;
  color: rgba(0, 0, 0, 0.8);
  border-radius: 4px;
  border: 1px solid rgba(233, 233, 233, 1);
  background-color: rgba(247, 248, 250, 1);
  &.checked,
  &:hover {
    border: 1px solid rgba(36, 0, 255, 0.16);
    background-color: rgba(36, 0, 255, 0.04);
  }
  .content-title {
    height: 18px;
    line-height: 18px;
    font-size: 13px;
  }
  .select_content {
    ::v-deep .el-input__inner {
      font-size: 13px;
      background: rgba(255, 255, 255, 1);
      box-shadow: 0px 0px 0px 1px rgba(233, 233, 233, 1) inset;
    }
  }
  &.checked {
    .select_content {
      ::v-deep .el-input__inner {
        font-size: 13px;
        background-color: rgba(36, 0, 255, 0.1);
        color: rgba(36, 0, 255, 1);
        box-shadow: 0px 0px 0px 1px rgba(36, 0, 255, 0.16) inset;
        &:hover {
          background-color: rgba(36, 0, 255, 0.2);
        }
      }
      ::v-deep .el-select__caret {
        color: rgba(36, 0, 255, 1);
      }
      ::v-deep .is-focus .el-input__inner {
        background-color: rgba(36, 0, 255, 0.2);
      }
    }
  }
  .mapping_date_content {
    height: 20px;
    .date-label {
      font-size: 13px;
      color: var(--thirdTextColor);
      margin-right: 4px;
    }
    ::v-deep .el-dropdown {
      font-size: 13px;
    }
  }
  .el-checkbox {
    margin-right: 4px;
  }
  .vedio-style {
    font-size: 13px;
  }
}
.text_content {
  background: var(--inputArrowBgColor);
  border: 1px solid var(--borderColorTen);
  border-radius: 4px;
  padding: 8px;
  color: var(--elCollapseItemContentColor);
  &:not(:last-child) {
    margin-bottom: 8px;
  }
  &:hover {
    background: var(--themeColorSelectBg);
  }
  .el-checkbox {
    margin-right: 4px;
  }
  ::v-deep .el-input .el-input__inner {
    background-color: var(--leftMenuBgColor);
  }
}
.custom-dropdown {
  .dropdown-title-show {
    padding: 7px 12px;
    border-bottom: 1px solid rgba(233, 233, 233, 1);
    ::v-deep .el-checkbox__label {
      font-size: 13px;
    }
  }
  ::v-deep .el-dropdown-menu__item {
    height: 34px;
    line-height: 34px;
    font-size: 13px;
    color: rgba(0, 0, 0, 0.8);
    .active {
      color: rgba(43, 103, 255, 1);
    }
  }
}
</style>
